import React, { Component } from "react";
import { MdExpandMore, MdInfo } from "react-icons/md";
import Moment from "react-moment";
import showInfo from "./show_info";
const statusItem = require("../status.json");

class ListSends extends Component {
  render() {
    const { filter, movements, items, senders, selectedContent } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div className="sends-content">
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={
                filter
                  ? {
                      width: "100%",
                      margin: "auto",
                      height: "auto",
                      display: "block",
                      position: "relative",
                      boxShadow:
                        "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                      fontSize: "1.1rem",
                      marginTop: "250px"
                    }
                  : {
                      width: "100%",
                      margin: "auto",
                      height: "auto",
                      display: "block",
                      position: "relative",
                      boxShadow:
                        "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                      fontSize: "1.1rem",
                      marginTop: "125px"
                    }
              }
            >
              {selectedContent.length > 0 ? (
                selectedContent
                  .filter(
                    movement => movement.id_transacao === parseInt(filter, 10)
                  )
                  .map((movement, i) => (
                    <React.Fragment key={i}>
                      <div
                        className="accordion md-accordion accordion-blocks"
                        id="accordionEx78"
                        role="tablist"
                        aria-multiselectable="true"
                        style={{
                          alignContent: "left",
                          backgroundColor: "white",
                          display: "block",
                          margin: "auto"
                        }}
                      >
                        <div className="card white" id={"card" + i}>
                          <div
                            className="card-header"
                            role="tab"
                            id={"headingUnfiled" + i}
                            style={
                              movement.status === "ativa"
                                ? {
                                    backgroundColor: "#357ae8"
                                  }
                                : {
                                    backgroundColor: "gray"
                                  }
                            }
                          >
                            <a
                              data-toggle="collapse"
                              data-parent={"#card" + i}
                              href={"#collapseUnfiled" + i}
                              aria-expanded="true"
                              aria-controls="collapseUnfiled"
                            >
                              <h5 className="mt-4 mb-0">
                                <span style={{ color: "white" }}>
                                  Envio
                                  <p
                                    className="right"
                                    style={{ color: "white" }}
                                  >
                                    <MdExpandMore />
                                  </p>
                                </span>
                              </h5>
                            </a>
                          </div>
                          <div
                            id={"collapseUnfiled" + i}
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby={"headingUnfiled" + i}
                            data-parent={"#card" + i}
                          >
                            <div className="card-body">
                              <React.Fragment>
                                <div
                                  className="row justify-content-center"
                                  style={{
                                    display: "block",
                                    margin: "auto",
                                    width: "100%"
                                  }}
                                >
                                  <div className="col s12">
                                    <table className="table table-responsive table-sm table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">ID Malote</th>
                                          <th scope="col">ID Movimentação</th>
                                          <th scope="col">Remetente</th>
                                          <th scope="col">Destinatário</th>
                                          <th scope="col">Data de Criação</th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            Data de Modificação
                                          </th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            <i>Status</i>
                                          </th>
                                          <th scope="col">ID Item</th>
                                          <th scope="col">Tipo</th>
                                          <th scope="col">Descrição</th>
                                          <th scope="col">Patrimônio</th>
                                          <th scope="col">Observação</th>
                                          <th scope="col">
                                            <i>Status</i>
                                          </th>
                                          <th scope="col">
                                            <i>Info</i>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bolder"
                                            }}
                                          >
                                            {movement.id_transacao}
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bolder"
                                            }}
                                          >
                                            {movement.id_movimentacao}
                                          </td>
                                          {senders.length > 0 &&
                                            senders
                                              .filter(
                                                sender =>
                                                  sender.id ===
                                                  movement.id_remetente
                                              )
                                              .map((sender, l) => (
                                                <td key={l}>
                                                  {sender.usuario
                                                    .toUpperCase()
                                                    .replace(".", " ")}
                                                </td>
                                              ))}
                                          {senders.length > 0 &&
                                            senders
                                              .filter(
                                                recipient =>
                                                  recipient.id ===
                                                  movement.id_destinatario
                                              )
                                              .map(
                                                (recipient, l) =>
                                                  l === 0 && (
                                                    <td key={l}>
                                                      {recipient.usuario
                                                        .toUpperCase()
                                                        .replace(".", " ")}
                                                    </td>
                                                  )
                                              )}
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {movement.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {movement.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {movement.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {movement.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <i
                                              style={
                                                movement.status === "ativa"
                                                  ? {
                                                      color: "#357ae8"
                                                    }
                                                  : {
                                                      color: "red"
                                                    }
                                              }
                                            >
                                              {movement.status.toUpperCase()}
                                            </i>
                                          </td>
                                          {items.length > 0 &&
                                            items
                                              .filter(
                                                item =>
                                                  item.id_item ===
                                                  movement.id_item
                                              )
                                              .map(
                                                (item, j) =>
                                                  j === 0 && (
                                                    <React.Fragment key={j}>
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {item.id_item}
                                                      </td>
                                                      <td>
                                                        {item.tipo.toUpperCase()}
                                                      </td>
                                                      <td>
                                                        {item.descricao &&
                                                          (item.descricao
                                                            .length <= 15 ? (
                                                            item.descricao
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_descricao"
                                                              maxLength="100"
                                                              value={
                                                                item.descricao
                                                              }
                                                              readOnly
                                                            />
                                                          ))}
                                                      </td>
                                                      <td>
                                                        {item.patrimonio ? (
                                                          item.patrimonio
                                                            .length <= 15 ? (
                                                            item.patrimonio
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_patrimonio"
                                                              maxLength="30"
                                                              value={
                                                                item.patrimonio
                                                              }
                                                              readOnly
                                                            />
                                                          )
                                                        ) : (
                                                          "----"
                                                        )}
                                                      </td>
                                                      <td>
                                                        {item.observacao ? (
                                                          item.observacao
                                                            .length <= 15 ? (
                                                            item.observacao
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_observacao"
                                                              maxLength="1000"
                                                              value={
                                                                item.observacao
                                                              }
                                                              readOnly
                                                            />
                                                          )
                                                        ) : (
                                                          "----"
                                                        )}
                                                      </td>
                                                      <td>
                                                        {statusItem
                                                          .filter(
                                                            status =>
                                                              status.id_status ===
                                                              item.status
                                                          )
                                                          .map((status, k) => (
                                                            <span key={k}>
                                                              <i
                                                                style={
                                                                  item.status ===
                                                                  4
                                                                    ? {
                                                                        color:
                                                                          "red"
                                                                      }
                                                                    : item.status ===
                                                                      3
                                                                    ? {
                                                                        color:
                                                                          "green"
                                                                      }
                                                                    : item.status ===
                                                                      2
                                                                    ? {
                                                                        color:
                                                                          "tomato"
                                                                      }
                                                                    : item.status ===
                                                                      1
                                                                    ? {
                                                                        color:
                                                                          "#357ae8"
                                                                      }
                                                                    : {
                                                                        color:
                                                                          "black"
                                                                      }
                                                                }
                                                              >
                                                                {status.status.toUpperCase()}
                                                              </i>
                                                            </span>
                                                          ))}
                                                      </td>
                                                      <td>
                                                        <MdInfo
                                                          style={{
                                                            fontSize: "1.2rem"
                                                          }}
                                                          onClick={() =>
                                                            showInfo(item)
                                                          }
                                                        />
                                                      </td>
                                                    </React.Fragment>
                                                  )
                                              )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  ))
              ) : selectedContent && movements.length > 0 ? (
                movements.map((movement, i) => (
                  <React.Fragment key={i}>
                    <div
                      className="box-search"
                      style={{
                        backgroundColor: "white"
                      }}
                    >
                      <div
                        className="accordion md-accordion accordion-blocks"
                        id="accordionEx78"
                        role="tablist"
                        aria-multiselectable="true"
                        style={{
                          alignContent: "left",
                          backgroundColor: "white",
                          display: "block",
                          margin: "auto"
                        }}
                      >
                        <div className="card white" id={"card" + i}>
                          <div
                            className="card-header"
                            role="tab"
                            id={"headingUnfiled" + i}
                            style={
                              movement.status === "ativa"
                                ? {
                                    backgroundColor: "#357ae8"
                                  }
                                : {
                                    backgroundColor: "gray"
                                  }
                            }
                          >
                            <a
                              data-toggle="collapse"
                              data-parent={"#card" + i}
                              href={"#collapseUnfiled" + i}
                              aria-expanded="true"
                              aria-controls="collapseUnfiled"
                            >
                              <h5 className="mt-4 mb-0">
                                <span style={{ color: "white" }}>
                                  Envio
                                  <p
                                    className="right"
                                    style={{ color: "white" }}
                                  >
                                    <MdExpandMore />
                                  </p>
                                </span>
                              </h5>
                            </a>
                          </div>
                          <div
                            id={"collapseUnfiled" + i}
                            className="collapse show"
                            role="tabpanel"
                            aria-labelledby={"headingUnfiled" + i}
                            data-parent={"#card" + i}
                          >
                            <div className="card-body">
                              <React.Fragment>
                                <div
                                  className="row justify-content-center"
                                  style={{
                                    display: "block",
                                    margin: "auto",
                                    width: "100%"
                                  }}
                                >
                                  <div className="col s12">
                                    <table className="table table-responsive table-sm table-hover">
                                      <thead>
                                        <tr>
                                          <th scope="col">ID Malote</th>
                                          <th scope="col">ID Movimentação</th>
                                          <th scope="col">Remetente</th>
                                          <th scope="col">Destinatário</th>
                                          <th scope="col">Data de Criação</th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            Data de Modificação
                                          </th>
                                          <th scope="col">Horário</th>
                                          <th scope="col">
                                            <i>Status</i>
                                          </th>
                                          <th scope="col">ID Item</th>
                                          <th scope="col">Tipo</th>
                                          <th scope="col">Descrição</th>
                                          <th scope="col">Patrimônio</th>
                                          <th scope="col">Observação</th>
                                          <th scope="col">
                                            <i>Status</i>
                                          </th>
                                          <th scope="col">
                                            <i>Info</i>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bolder"
                                            }}
                                          >
                                            {movement.id_transacao}
                                          </td>
                                          <td
                                            style={{
                                              fontWeight: "bolder"
                                            }}
                                          >
                                            {movement.id_movimentacao}
                                          </td>
                                          {senders.length > 0 &&
                                            senders
                                              .filter(
                                                sender =>
                                                  sender.id ===
                                                  movement.id_remetente
                                              )
                                              .map((sender, l) => (
                                                <td key={l}>
                                                  {sender.usuario
                                                    .toUpperCase()
                                                    .replace(".", " ")}
                                                </td>
                                              ))}
                                          {senders.length > 0 &&
                                            senders
                                              .filter(
                                                recipient =>
                                                  recipient.id ===
                                                  movement.id_destinatario
                                              )
                                              .map(
                                                (recipient, l) =>
                                                  l === 0 && (
                                                    <td key={l}>
                                                      {recipient.usuario
                                                        .toUpperCase()
                                                        .replace(".", " ")}
                                                    </td>
                                                  )
                                              )}
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {movement.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {movement.created_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment format="DD/MM/YYYY">
                                              {movement.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <Moment
                                              add={{ hours: 3 }}
                                              format="HH:mm:ss"
                                            >
                                              {movement.updated_at}
                                            </Moment>
                                          </td>
                                          <td>
                                            <i
                                              style={
                                                movement.status === "ativa"
                                                  ? {
                                                      color: "#357ae8"
                                                    }
                                                  : {
                                                      color: "red"
                                                    }
                                              }
                                            >
                                              {movement.status.toUpperCase()}
                                            </i>
                                          </td>
                                          {items.length > 0 &&
                                            items
                                              .filter(
                                                item =>
                                                  item.id_item ===
                                                  movement.id_item
                                              )
                                              .map(
                                                (item, j) =>
                                                  j === 0 && (
                                                    <React.Fragment key={j}>
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {item.id_item}
                                                      </td>
                                                      <td>
                                                        {item.tipo.toUpperCase()}
                                                      </td>
                                                      <td>
                                                        {item.descricao &&
                                                          (item.descricao
                                                            .length <= 15 ? (
                                                            item.descricao
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_descricao"
                                                              maxLength="100"
                                                              value={
                                                                item.descricao
                                                              }
                                                              readOnly
                                                            />
                                                          ))}
                                                      </td>
                                                      <td>
                                                        {item.patrimonio ? (
                                                          item.patrimonio
                                                            .length <= 15 ? (
                                                            item.patrimonio
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_patrimonio"
                                                              maxLength="30"
                                                              value={
                                                                item.patrimonio
                                                              }
                                                              readOnly
                                                            />
                                                          )
                                                        ) : (
                                                          "----"
                                                        )}
                                                      </td>
                                                      <td>
                                                        {item.observacao ? (
                                                          item.observacao
                                                            .length <= 15 ? (
                                                            item.observacao
                                                          ) : (
                                                            <textarea
                                                              style={{
                                                                border: "none"
                                                              }}
                                                              className="form-control white"
                                                              id="view_observacao"
                                                              maxLength="1000"
                                                              value={
                                                                item.observacao
                                                              }
                                                              readOnly
                                                            />
                                                          )
                                                        ) : (
                                                          "----"
                                                        )}
                                                      </td>
                                                      <td>
                                                        {statusItem
                                                          .filter(
                                                            status =>
                                                              status.id_status ===
                                                              item.status
                                                          )
                                                          .map((status, k) => (
                                                            <span key={k}>
                                                              <i
                                                                style={
                                                                  item.status ===
                                                                  4
                                                                    ? {
                                                                        color:
                                                                          "red"
                                                                      }
                                                                    : item.status ===
                                                                      3
                                                                    ? {
                                                                        color:
                                                                          "green"
                                                                      }
                                                                    : item.status ===
                                                                      2
                                                                    ? {
                                                                        color:
                                                                          "tomato"
                                                                      }
                                                                    : item.status ===
                                                                      1
                                                                    ? {
                                                                        color:
                                                                          "#357ae8"
                                                                      }
                                                                    : {
                                                                        color:
                                                                          "black"
                                                                      }
                                                                }
                                                              >
                                                                {status.status.toUpperCase()}
                                                              </i>
                                                            </span>
                                                          ))}
                                                      </td>
                                                      <td>
                                                        <MdInfo
                                                          style={{
                                                            fontSize: "1.2rem"
                                                          }}
                                                          onClick={() =>
                                                            showInfo(item)
                                                          }
                                                        />
                                                      </td>
                                                    </React.Fragment>
                                                  )
                                              )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </React.Fragment>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <p style={{ paddingTop: "25px" }}>
                  Nenhum registro encontrado.
                </p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ListSends;
